import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import LMElogo from "../../assets/images/La-Movida-Esta-Logo.png";

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar__logo">
        <Link to="/">
          <img src={LMElogo} alt="La Movida Esta Logo"></img>
        </Link>
      </div>
      <div className="navbar__menu">
        <ul className="navbar__menu__list">
          <li>
            <a
              className="navbar__menu__list__item"
              href="https://open.spotify.com/show/0bl0g59QzCk5Kf1IU4Pxp8?si=403fe293f3874157"
              target="_blank"
              rel="noopener noreferrer"
            >
              Spotify
            </a>
          </li>

          <li>
            <a
              className="navbar__menu__list__item"
              href="https://www.ivoox.com/podcast-movida-esta_sq_f12485270_1.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              iVoox
            </a>
          </li>
          <li>
            <a
              className="navbar__menu__list__item"
              href="https://www.youtube.com/@LaMovidaEsta"
              target="_blank"
              rel="noopener noreferrer"
            >
              YouTube
            </a>
          </li>

          <li>
            <Link
              to="/consultorio-del-amor"
              className="navbar__menu__list__item"
            >
              Consultorio del amor
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
